module.exports = __webpack_public_path__ + "static/media/icon-check-green.b1d83215.svg";